import PropTypes from 'prop-types';
import React, { createContext, useContext } from 'react';

import SmallCaps from './SmallCaps';
import styles from './VisitSections.module.scss';

const LayoutContext = createContext('card');

export const VisitSections = ({ children, layout = 'card', className }) => (
  <LayoutContext.Provider value={layout}>
    <div
      className={[styles.box, layout === 'brief' ? styles.briefBox : '', className]
        .filter(Boolean)
        .join(' ')}
    >
      <div className={`${styles.grid} ${layout === 'brief' ? styles.briefGrid : ''}`}>
        {children}
      </div>
    </div>
  </LayoutContext.Provider>
);

export const VisitSection = ({ label, children, className }) => {
  const brief = useContext(LayoutContext) === 'brief';
  return (
    <section
      aria-label={label}
      className={[styles.section, brief ? styles.briefSection : '', className]
        .filter(Boolean)
        .join(' ')}
    >
      <SmallCaps as={brief ? 'h3' : 'h4'} tone={brief ? 'strong' : 'label'}>
        {label}
      </SmallCaps>
      {children}
    </section>
  );
};

export const FactRows = ({ rows }) => (
  <dl className={styles.factRows}>
    {rows.map(({ label, value }) => (
      <div key={label} className={styles.factRow}>
        <SmallCaps as="dt">{label}</SmallCaps>
        <dd className={styles.factRowValue}>{value}</dd>
      </div>
    ))}
  </dl>
);

export const FactSection = ({ label, children, className }) => (
  <VisitSection label={label} className={[styles.fact, className].filter(Boolean).join(' ')}>
    <div className={styles.factValue}>{children}</div>
  </VisitSection>
);

VisitSections.propTypes = {
  children: PropTypes.node,
  layout: PropTypes.oneOf(['card', 'brief']),
  className: PropTypes.string,
};
FactRows.propTypes = {
  rows: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string.isRequired, value: PropTypes.node }),
  ).isRequired,
};
VisitSection.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
};
FactSection.propTypes = VisitSection.propTypes;
